<template>
	<!-- Topnav -->
	<nav :class="classNavbar">
		<div class="container-fluid">
			<div class="collapse navbar-collapse" id="navbarSupportedContent">
				<!-- Search form -->

				<nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
					<ol class="breadcrumb breadcrumb-links">
						<li class="breadcrumb-item"><router-link :to="linkHome"><strong>Inicio</strong></router-link></li>
						<li class="breadcrumb-item active" aria-current="page"> </li>
					</ol>
				</nav>

				<!-- Navbar links -->
				<ul class="navbar-nav align-items-center ml-md-auto">
					<li class="nav-item d-xl-none">
						<!-- Sidenav toggler -->
						<div class="pr-3 sidenav-toggler sidenav-toggler-light" data-action="sidenav-pin" data-target="#sidenav-main">
							<div class="sidenav-toggler-inner">
								<i class="sidenav-toggler-line"></i>
								<i class="sidenav-toggler-line"></i>
								<i class="sidenav-toggler-line"></i>
							</div>
						</div>
					</li>

				</ul>
				<ul class="navbar-nav align-items-center ml-auto ml-md-0" v-if="usuario">
					<li class="nav-item dropdown">
						<a class="nav-link pr-0" href="#" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
							<div class="media align-items-center">

								<div class="media-body ml-2 d-none d-lg-block">
									<span class="mb-0 text-sm  font-weight-bold">{{usuario.nombre}} {{usuario.apellidos}}</span>
								</div>
							</div>
						</a>
						<div class="dropdown-menu dropdown-menu-right">

							<router-link to="/profile" class="dropdown-item">
								<i class="ni ni-single-02"></i>
								<span>Mi perfil</span>
							</router-link>
							<a href="#!" class="dropdown-item">
								<i class="ni ni-settings-gear-65"></i>
								<span>Configuración</span>
							</a>

							<router-link to="/home" class="dropdown-item" v-if="usuario.tipo_usuario_pro == 2">
								<i class="ni ni-settings-gear-65"></i>
								<span>Mis cursos</span>
							</router-link>
							<router-link to="/home-teacher" class="dropdown-item" v-if="usuario.tipo_usuario_pro == 2">
								<i class="ni ni-settings-gear-65"></i>
								<span>Panel docente</span>
							</router-link>
							<div class="dropdown-divider"></div>
							<router-link to="/login?logout=1" class="dropdown-item">
								<i class="ni ni-user-run"></i>
								<span>Cerrar sesión</span>
							</router-link>
						</div>
					</li>
				</ul>
			</div>
		</div>
	</nav>
</template>
<script>
	export default {
		name: 'HeaderComponent',
		data() {
			return {
				usuario: user,
				linkHome: '/home',
				hostname: '',
				classNavbar: 'navbar navbar-top navbar-expand navbar-light bg-gradient-light border-bottom'
			}
		},
		async mounted() {
			this.hostname = hostname
			if(!user) {
                await this.getUserApi()
				this.usuario = user
			}
			
			if(this.usuario.tipo_usuario_pro == 2)
				this.linkHome = '/home-teacher'

			if(hostname == 'seducoahuila.etciberoamerica.com') {
				this.classNavbar = 'navbar navbar-top navbar-expand navbar-light bg-purple border-bottom'
			}
		}
	}
</script>